(function($) {
  $(window).scroll( function( e ){ 
    if( $(this).scrollTop() > $('#main-content').offset().top ){
      $("#totop").removeClass("hide");
    } else {
      $("#totop").addClass("hide");
    }
  });
})( jQuery );